var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 14.6667C11.6732 14.6667 14.6665 11.6734 14.6665 8.00008C14.6665 4.32675 11.6732 1.33342 7.99984 1.33342C4.32651 1.33342 1.33317 4.32675 1.33317 8.00008C1.33317 11.6734 4.3265 14.6667 7.99984 14.6667ZM8.49984 10.6667C8.49984 10.9401 8.27317 11.1667 7.99984 11.1667C7.7265 11.1667 7.49984 10.9401 7.49984 10.6667L7.49984 7.33341C7.49984 7.06008 7.72651 6.83341 7.99984 6.83341C8.27317 6.83341 8.49984 7.06008 8.49984 7.33341L8.49984 10.6667ZM7.38651 5.08008C7.41984 4.99342 7.4665 4.92675 7.52651 4.86008C7.59317 4.80008 7.66651 4.75341 7.74651 4.72008C7.82651 4.68675 7.91317 4.66675 7.99984 4.66675C8.08651 4.66675 8.17317 4.68675 8.25317 4.72008C8.33317 4.75341 8.40651 4.80008 8.47317 4.86008C8.53317 4.92675 8.57984 4.99342 8.61317 5.08008C8.64651 5.16008 8.66651 5.24675 8.66651 5.33341C8.66651 5.42008 8.64651 5.50675 8.61317 5.58675C8.57984 5.66675 8.53317 5.74008 8.47317 5.80675C8.4065 5.86675 8.33317 5.91341 8.25317 5.94675C8.09317 6.01341 7.9065 6.01341 7.74651 5.94675C7.66651 5.91341 7.59317 5.86675 7.52651 5.80675C7.4665 5.74008 7.41984 5.66675 7.3865 5.58675C7.35317 5.50675 7.33317 5.42008 7.33317 5.33341C7.33317 5.24675 7.35317 5.16008 7.38651 5.08008Z",
    fill: "#2A3967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.5b872c6344b19a1df7d9bd42640cb364.svg";
export { ForwardRef as ReactComponent };